import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IGrandRecognition } from 'src/app/interfaces/IRecognitions';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class RecognitionsService {

  apiKey = environment.gluky.apikey;
  appId = environment.gluky.app_id;
  urlRecognitions = environment.gluky.recognitionsUrl;

  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private authService: AuthService
  ) { }

  async getRecognitionsType() {
    const token = await this.storageService.get("gnx-token");
    const claims = await this.storageService.get("gnx-claims");
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${token}` });
    return new Promise((resolve, reject) => {
      this.http.get(`${this.urlRecognitions}/front/recognition_type/user/${claims.uid}/application/${this.appId}?key=${this.apiKey}`,
        {
          headers
        })
        .subscribe((res) => {
          resolve(res);
        },
          (err) => {
            reject(err);
          });
    })
  }

  async getCollaborators(id: string, searchName: string) {
    const token = await this.storageService.get("gnx-token");
    const claims = await this.storageService.get("gnx-claims");
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${token}` });

    return new Promise((resolve, reject) => {
      this.http.get(`${this.urlRecognitions}/front/recognition_type/user/${claims.uid}/grantable-users/${id}?key=${this.apiKey}&search_name=${searchName}`,
        {
          headers
        })
        .subscribe((res) => {
          resolve(res);
        },
          (err) => {
            reject(err);
          });
    })

  }

  async grandRecognition(body: IGrandRecognition) {

    const claims = await this.storageService.get("gnx-claims");
    const token = await this.storageService.get("gnx-token");
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${token}` });

    return new Promise((resolve, reject) => {
      this.http.post(
        `${this.urlRecognitions}/front/user/${claims.uid}/granted-recognitions?key=${this.apiKey}`,
        {
          ...body
        },
        {
          headers
        })
        .subscribe((res) => {
          resolve(res)
        },
          (err) => {
            reject(err)
          });
    })
  }

  async getReceivedRecognitions() {
    const token = await this.storageService.get("gnx-token");
    const claims = await this.storageService.get("gnx-claims");
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'X-Skip-Interceptor': '',
      'Content-Type':'application/json'
    });

    return new Promise((resolve, reject) => {
      this.http.get(`${this.urlRecognitions}/front/user/${claims.uid}/received-recognitions?key=${this.apiKey}`,
        {
          headers
        })
        .subscribe((res) => {
          resolve(res);
        },
          (err) => {
            reject(err);
          });
    })
  }

  async getGrantedRecognitions() {
    const token = await this.storageService.get("gnx-token");
    const claims = await this.storageService.get("gnx-claims");
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${token}` });

    return new Promise((resolve, reject) => {
      this.http.get(`${this.urlRecognitions}/front/user/${claims.uid}/granted-recognitions?key=${this.apiKey}`,
        {
          headers
        })
        .subscribe((res) => {
          resolve(res);
        },
          (err) => {
            reject(err);
          });
    })
  }

  async getGroupedRecognitions() {
    const token = await this.storageService.get("gnx-token");
    const claims = await this.storageService.get("gnx-claims");
    const headers = new HttpHeaders({ 
      'Authorization': `Bearer ${token}`, 
      'X-Skip-Interceptor': '',
      'Content-Type':'application/json'
    });

    return new Promise((resolve, reject) => {
      this.http.get(`${this.urlRecognitions}/front/user/${claims.uid}/grouped-received-recognitions?key=${this.apiKey}`,
        {
          headers
        })
        .subscribe((res) => {
          resolve(res);
        },
          (err) => {
            reject(err);
          });
    })
  }


  async getGroupedGrantedRecognitions() {
    const token = await this.storageService.get("gnx-token");
    const claims = await this.storageService.get("gnx-claims");
    const headers = new HttpHeaders({ 
      'Authorization': `Bearer ${token}`, 
      'X-Skip-Interceptor': '',
      'Content-Type':'application/json'
    });

    return new Promise((resolve, reject) => {
      this.http.get(`${this.urlRecognitions}/front/user/${claims.uid}/grouped-granted-recognitions?key=${this.apiKey}`,
        {
          headers
        })
        .subscribe((res) => {
          resolve(res);
        },
          (err) => {
            reject(err);
          });
    })
  }
}
